<template>
  <thead
    :class="`v-table-wrapper-header-${type}-table-thead`"
  >
  <tr
    :class="`v-table-wrapper-header-${type}-table-thead-row`"
    :row="0"
    ref="row"
  >
    <header-cell-default
      :class="`v-table-wrapper-header-${type}-table-thead-row-cell`"
      v-for="(column, index) in scope.props.headers"
      :key="'head-' + type + '-' + 'cell-' + index"
      :cell="index"
      :multi-sort="multiSort"
      :column="column"
      :type="type"
      :index="index"
    >

      <template
        v-for="(_, slotKey) of $scopedSlots"
        v-slot:[slotKey]="scopeFromCell"
      >
        <slot :name="slotKey" v-bind="{...scopeFromCell, column: column, headers: scope.props.headers}"></slot>
      </template>

    </header-cell-default>
  </tr>
  </thead>
</template>

<script>
  import HeaderCellDefault from './HeaderCellDefault'

  /**
   * для синхронизации высоты строк
   */
  // import ResizeObserver from 'resize-observer-polyfill'
  //
  // const rowSync = new ResizeObserver((entries) => {
  //   for (const entry of entries) {
  //     const {offsetHeight, rowIndex} = entry.target
  //     const ancestor = entry.target.closest('.v-table-wrapper-header')
  //     const otherTable = ancestor.querySelectorAll('.v-table-wrapper-header-fixed-table-thead-row')
  //     otherTable[rowIndex].style.height = offsetHeight + 'px'
  //   }
  // })

  export default {
    name: 'HeaderSlot',
    components: {HeaderCellDefault},
    props: {
      type: String,
      scope: Object,
      multiSort: Boolean,
    },
    methods: {
      createSlotKey(columnValue) {
        return `header.${columnValue}`
      }
    },
    mounted() {
      /**
       * для синхронизации высоты строк
       */
      // if (this.type === 'common') {
      //   rowSync.observe(this.$refs.row)
      // }
    }
  }

</script>

<style scoped>
</style>


